import script from "./NotesList.vue?vue&type=script&setup=true&lang=js"
export * from "./NotesList.vue?vue&type=script&setup=true&lang=js"

import "./NotesList.vue?vue&type=style&index=0&id=d02f056a&lang=scss&scoped=true"

import exportComponent from "/home/dev/g-nti/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d02f056a"]])

export default __exports__